export const PERMISSIONS = {
	MACHINE_READ: 'machine:read',
	MACHINE_CREATE: 'machine:create',
	MACHINE_EDIT: 'machine:edit',
	MACHINE_RESTART: 'machine:restart',
	MACHINE_RESET: 'machine:reset',
	MACHINE_UPDATE_VERSION: 'machine:update_version',
	MACHINE_SEND_VIRTUAL_CREDIT: 'machine:send_virtual_credit',
	MACHINE_DELETE: 'machine:delete',

	DEVICE_READ: 'device:read',

	PLANOGRAM_READ: 'planogram:read',
	PLANOGRAM_CREATE: 'planogram:create',
	PLANOGRAM_EDIT: 'planogram:edit',
	PLANOGRAM_DELETE: 'planogram:delete',
	PLANOGRAM_SYNCHRONIZE: 'planogram:synchronize',

	PLANOGRAM_CATALOG_READ: 'planogram:catalog:read',
	PLANOGRAM_CATALOG_CREATE: 'planogram:catalog:create',
	PLANOGRAM_CATALOG_EDIT: 'planogram:catalog:edit',
	PLANOGRAM_CATALOG_DELETE: 'planogram:catalog:delete',

	MASTER_READ: 'master:read',
	MASTER_CREATE: 'master:create',
	MASTER_EDIT: 'master:edit',
	MASTER_UPDATE_FIRMWARE: 'master:update_firmware',

	PRODUCT_READ: 'product:read',
	PRODUCT_CREATE: 'product:create',
	PRODUCT_EDIT: 'product:edit',
	PRODUCT_DELETE: 'product:delete',

	CLIENT_READ: 'client:read',
	CLIENT_CREATE: 'client:create',
	CLIENT_EDIT: 'client:edit',
	CLIENT_DELETE: 'client:delete',

	IRP_READ: 'irp:read',
	IRP_CREATE: 'irp:create',
	IRP_DELETE: 'irp:delete',
	IRP_EDIT: 'irp:edit',

	EVA_DTS_READ: 'eva_dts:read',
	EVA_DTS_CREATE: 'eva_dts:create',
	EVA_DTS_EDIT: 'eva_dts:edit',

	USER_READ: 'user:read',
	USER_SEND_VIRTUAL_CREDIT: 'user:send_virtual_credit',
	USER_BALANCE_CALCULATOR: 'user:balance_calculator',

	TAG_READ: 'tag:read',
	TAG_CREATE: 'tag:create',
	TAGS_EDIT: 'tag:edit',
	TAG_DELETE: 'tag:delete',
	TAG_BLOCK: 'tag:block',
	TAG_RESET_BALANCE: 'tag:reset_balance',
	TAG_SEND_VIRTUAL_CREDIT: 'tag:send_virtual_credit',
	TAG_TRANSFER_BALANCE: 'tag:transfer_balance',

	QR_READ: 'qr:read',
	QR_CREATE: 'qr:create',
	QR_DELETE: 'qr:delete',

	WHITELIST_READ: 'whitelist:read',
	WHITELIST_CREATE: 'whitelist:create',
	WHITELIST_EDIT: 'whitelist:edit',
	WHITELIST_DELETE: 'whitelist:delete',

	TICKET_READ: 'ticket:read',
	TICKET_EDIT: 'ticket:edit',

	PROMOTION_READ: 'promotion:read',
	PROMOTION_CREATE: 'promotion:create',
	PROMOTION_EDIT: 'promotion:edit',
	PROMOTION_DELETE: 'promotion:delete',
	PROMOTION_ACTIVE_DISABLED: 'promotion:active_disabled',
	PROMOTION_PRIORITIZE: 'promotion:prioritize',
	PROMOTION_USER_TARGET_EDITION: 'promotion:user_target_edition',

	SALESCONDITION_READ: 'salescondition:read',
	SALESCONDITION_CREATE: 'salescondition:create',
	SALESCONDITION_EDIT: 'salescondition:edit',
	SALESCONDITION_DELETE: 'salescondition:delete',
	SALESCONDITION_ACTIVE_DISABLED: 'salescondition:active_disabled',

	REPORT_READ: 'report:read',
	REPORT_CREATE: 'report:create',
	REPORT_EDIT: 'report:edit',
	REPORT_DELETE: 'report:delete',
	REPORT_GROUP: 'report:group',
	REPORT_CATALOGS: 'report:catalogs',
	REPORT_DUPLICATE_REPORT: 'report:duplicate:report',
	REPORT_SCHEDULE: 'report:schedule:report',
	REPORT_BUY: 'report:buy',

	TRANSACTION_READ: 'transaction:read',
	TRANSACTION_MANAGE_REFUND: 'transaction:manage_refund',

	FISCAL_DATA_READ: 'fiscal_data:read',
	FISCAL_DATA_EDIT: 'fiscal_data:edit',

	ERP_READ: 'erp:read',
	ERP_CREATE: 'erp:create',
	ERP_EDIT: 'erp:edit',

	ROLE_READ: 'role:read',
	ROLE_CREATE: 'role:create',
	ROLE_EDIT: 'role:edit',
	ROLE_DELETE: 'role:delete',

	EMPLOYEE_READ: 'employee:read',
	EMPLOYEE_CREATE: 'employee:create',
	EMPLOYEE_EDIT: 'employee:edit',
	EMPLOYEE_DELETE: 'employee:delete',

	SETTING_CURRENCY: 'setting:currency',
	SETTING_REFUNDS: 'setting:refunds',

	DELEGATION_READ: 'delegation:read',
	DELEGATION_EDIT: 'delegation:edit',
	DELEGATION_CREATE: 'delegation:create',
	DELEGATION_DELETE: 'delegation:delete',
	DELEGATION_FAKE_ACCESS: 'delegation:fake_access',

	TOKENS: 'tokens',
	COMPANY_FAKE_ACCESS: 'company:fake_access',

	ZOHO_BILLING: 'zoho:billing',

	// ADDONS

	CONCILIATION_READ: 'conciliation:read',
	CONCILIATION_BUY: 'conciliation:buy',

	ALERTS_READ: 'alerts:read',
	ALERTS_CREATE: 'alerts:create',
	ALERTS_EDIT: 'alerts:edit',
	ALERTS_DELETE: 'alerts:delete',
	ALERTS_BUY: 'alerts:buy',
	ALERTS_FOAM: 'alerts:foam',
	ALERTS_CONEXIONS: 'alerts:conexions',
	ALERTS_SALES: 'alerts:sales',
	ALERTS_OOS: 'alerts:oos',
	ALERTS_PAYMENT_INACTIVES: 'alerts:payment_inactives',

	POS_PERSONALIZATION_READ: 'pos_personalization:read',
	POS_PERSONALIZATION_CREATE: 'pos_personalization:create',
	POS_PERSONALIZATION_EDIT: 'pos_personalization:edit',
	POS_PERSONALIZATION_DELETE: 'pos_personalization:delete',
	POS_PERSONALIZATION_BUY: 'pos_personalization:buy',
	POS_PERSONALIZATION_SEND_TO_VALIDATE: 'pos_personalization:send_to_validate',

	ADS_READ: 'ads:read',
	ADS_EDIT: 'ads:edit',

	TABLE_CONTROL: 'table_control',

	DEVICES_MARKETPLACE_READ: 'devices_marketplace:read',
	DEVICES_MARKETPLACE_CREATE: 'devices_marketplace:create',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export function toPermissionKey(permission: string): string {
	return permission.replace(/:/g, '_').toUpperCase();
}
